import { gql } from "@apollo/client";

export const generateReport = gql`
  mutation ReportOnQuery($data: Query_data) {
    reportOnQuery(query_data: $data)
  }
`;

export const getStatementPaymennts = gql`
  query GetPaidChequesForStatement {
    getPaidChequesForStatement {
      cheque_number
      reinsured
      offer_ids
      payment_ids
    }
  }
`;

export const getBatchReports = gql`
query GetBatchReports($filter: BatchReportFilter, $pagination: Pagination) {
  count: getBatchReportsCount(filter: $filter)
  data: getBatchReports(filter: $filter, pagination: $pagination) {
    report_id
    status
    request_body
    downloadable_xlsx_link
    downloadable_pdf_link
    created_at
    updated_at
    employee {
      employee_id
      employee_first_name
      employee_last_name
      employee_phonenumber
      employee_email
      emp_abbrv
      accept_waiver_aggreement
      waiver_accepted_at
    }
    description
  }
}
`;
